import React, {Component} from 'react';
import {connect} from 'react-redux'
import GeneralDoc from './GeneralDoc'
class BillingNoteDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:{doc:{},itemlist:[]}}
  }

  componentDidMount(){
    
  }

  componentWillMount() {
    // Instantiate a Realtime client 
  }

  loadNewDoc(callback) {
    
    this.refs.genDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (callback!==undefined)
        callback(result.creditnote_no)
      
    },)
  }

  loadData(docNo) {
    this.refs.genDoc.getWrappedInstance().loadData(docNo)
  }

  setDataFromTaxinvoice(data) {
    this.refs.genDoc.getWrappedInstance().setDataFromTaxinvoice(data)
  }

  renameDoc() {
    
  }

  onDocClose() {
    if (this.props.onClose!==undefined)
      this.props.onClose()
  }

  render() {
    return(
      <GeneralDoc
        ref={'genDoc'}
        title={this.props.title} 
        docType={this.props.docType}
        docSName={this.props.docSName}
        docName={this.props.docName}
        showDiscount={false}
        onLoadData={(data)=>{
          this.setState({data:data})
        }}
        onClose={this.onDocClose.bind(this)}
      />
    )
  }
}

export default BillingNoteDoc = connect(
  (state) => ({messages: state.message.view.doc.DeliverySlipDoc}),null,null,{withRef:true}
)(BillingNoteDoc);





// WEBPACK FOOTER //
// ./src/view/doc/BillingNoteDoc.js